/**
 * @name ProcEqptList.js
 * @author 김권영
 * @since 2025. 02. 27.
 * @description
 * 공통 공정 설비 목록 조회 (Acc.js, Emp.js 에서 사용)
 * 회사-사업장 구조로 변경하여 siteCode 기준으로 조회
 *
 */
import React, { useState, useEffect } from 'react';
import { get } from '@utils/axios_api';

const ProcEqptList = ({ compCode, siteCode, selectedProcEqpt, onRowClick }) => {
    const [eqptList, setEqptList] = useState([]);

    useEffect(() => {
        // siteCode가 없으면 목록을 초기화
        if (!siteCode) {
            setEqptList([]);
            return;
        }

        const fetchEqptList = async () => {
            try {
                const data = await get('/user/accEqpt', {
                    params: {
                        siteCode: siteCode, // siteCode 파라미터 전달
                        compCode: compCode  // compCode도 함께 전달 (필요시)
                    },
                });

                setEqptList(data.procEqptList || []);
            } catch (err) {
                setEqptList([]);
            }
        };

        fetchEqptList();
    }, [siteCode, compCode]); // siteCode와 compCode 둘 다 의존성에 추가

    return (
        <section className="section-style">
            <div className="section-tit-wrap" style={{height:"5%"}}>
                <h3 className="border-left-primary">&nbsp;공정별 설비목록</h3>
            </div>

            <div className="acc-table-wrap">
                <table className="grid-list acc-list">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "45%" }} />
                        <col style={{ width: "40%" }} />
                    </colgroup>
                    <thead>
                    <tr>
                        <th>순번</th>
                        <th>공정</th>
                        <th>설비/장비</th>
                    </tr>
                    </thead>
                    <tbody>
                    {eqptList.map((item, idx) => (
                        <tr
                            key={item.mpreqCode}
                            onClick={() => onRowClick(item)}
                            style={{
                                backgroundColor:
                                    selectedProcEqpt === item.mpreqCode ? "#f2f2f2" : "",
                                cursor: "pointer",
                            }}
                        >
                            <td>{idx + 1}</td>
                            <td style={{textAlign:"left"}}>{item.procName}</td>
                            <td style={{textAlign:"left"}}>{item.eqptName}</td>
                        </tr>
                    ))}
                    {eqptList.length === 0 && (
                        <tr>
                            <td colSpan={3} style={{ textAlign: "center" }}>
                                {siteCode ? '해당 사업장에 데이터가 없습니다.' : '사업장을 선택하세요.'}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </section>
    );
};

export default ProcEqptList;
